import React, { useEffect, useRef } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import Button from "@mui/material/Button";
import Avatar from "@mui/material/Avatar";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import ListItemText from "@mui/material/ListItemText";
import DialogTitle from "@mui/material/DialogTitle";
import Dialog from "@mui/material/Dialog";
import PersonIcon from "@mui/icons-material/Person";
import { CreateSharp } from "@mui/icons-material";
import AddIcon from "@mui/icons-material/Add";
import Typography from "@mui/material/Typography";
import { blue } from "@mui/material/colors";
import {
  createPlayList,
  addSongToPlayListRequest,
  initPlayLists,
} from "./../../store/actions/playList";
import { closeDialog } from "./../../store/actions/dialogActions";
import { ButtonBase, TextField } from "@mui/material";
import { addPlaylist } from "./../../utils/amplitude-util";
import ListOfPlaylists from "./ListOfPlaylists";
import styles from "./style.module.css";
const emails = ["username@gmail.com", "user02@gmail.com"];
function SimpleDialog({
  open,
  onClose,
  playLists,
  createNewPlayList,
  addSong,
  selectedSong,
  initPlayListsProp,
}) {
  const dialogRef = useRef(null);
  useEffect(() => {
    initPlayListsProp(initPlayLists());
    console.log("**dialog ref", dialogRef.current);
  }, []);

  const inputFiled = useRef(null);
  const handleClose = () => {
    onClose();
  };

  console.log("playlist dialog", playLists);
  return (
    <Dialog
      fullWidth={true}
      classes={{
        root: open ? `${styles.dialogOpen}` : `${styles.dialogClose}`,
      }}
      onClose={handleClose}
      open={true}
      scroll={"paper"}>
      <DialogTitle>Create Your Playlists</DialogTitle>
      <ListOfPlaylists
        playLists={playLists}
        createNewPlayList={createNewPlayList}
        addSong={addSong}
      />
    </Dialog>
  );
}

SimpleDialog.propTypes = {
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  selectedValue: PropTypes.string.isRequired,
};

function SimpleDialogDemo({
  isOpen,
  playLists,
  createNewPlayList,
  close,
  addSong,
  selectedSong,
  initPlayListsProp,
}) {
  const [selectedValue, setSelectedValue] = React.useState(emails[1]);

  const handleClickOpen = () => {};

  const handleClose = (value) => {
    close();
  };

  return (
    <div>
      <SimpleDialog
        selectedSong={selectedSong}
        addSong={addSong}
        createNewPlayList={createNewPlayList}
        playLists={playLists}
        selectedValue={selectedValue}
        open={isOpen}
        onClose={handleClose}
        initPlayListsProp={initPlayListsProp}
      />
    </div>
  );
}
const mapStateToProps = (state, ownProps) => {
  return {
    isOpen: state.isDialogOpened,
    playLists: state.playLists,
    selectedSong: state.selectedSong,
  };
};
const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    createNewPlayList: (action) => {
      dispatch(action);
    },
    initPlayListsProp: (action) => {
      dispatch(action);
    },
    close: () => {
      dispatch(closeDialog());
    },
    addSong: (playlistName) => {
      dispatch(addSongToPlayListRequest(playlistName));
    },
    addSongToPlayList: (song, playListKey) => {
      dispatch();
    },
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(SimpleDialogDemo);
